// Text source reader (§pass1-prepare). Strict UTF-8 decode (rejects invalid
// bytes), BOM strip, CRLF/CR → LF. Markdown is preserved verbatim (order,
// headings, lists) — no screenplay interpretation here. DOCX reuses the existing
// OpenXML converter, then goes through the same normalization.

import * as fs from "node:fs";

import { convertDocx } from "../converters.js";

export class SourceDecodeError extends Error {}

function normalize(text: string): string {
  return text.replace(/^﻿/, "").replace(/\r\n?/g, "\n");
}

function decodeUtf8Strict(buf: Buffer): string {
  try {
    return new TextDecoder("utf-8", { fatal: true }).decode(buf);
  } catch {
    throw new SourceDecodeError("source is not valid UTF-8");
  }
}

export async function readTextSource(sourcePath: string, ext: string): Promise<string> {
  if (ext === ".docx") {
    const [text] = await convertDocx(sourcePath);
    return normalize(text);
  }
  return normalize(decodeUtf8Strict(fs.readFileSync(sourcePath)));
}
